/* eslint-disable react/prop-types */
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import useParamsHandler from "../../../utils/hooks/useParamsHandler";

import { usePagination } from "../../../utils/usePagination";
import Flex from "../Flex";

export const AdvanceTableFooter = ({
  currentPage,
  limit,
  pageSize,
  rowInfo,
  rowsPerPageSelection,
  navButtons,
  rowsPerPageOptions = [10, 20, 50, 100],
  className,
  totalCount,
}) => {
  const paginationRange = usePagination({
    currentPage: currentPage,
    totalCount: totalCount,
    siblingCount: 1,
    pageSize: limit,
  });

  const { searchParamsHandler } = useParamsHandler();

  return (
    <Flex
      className={classNames(
        className,
        "align-items-center justify-content-between",
      )}>
      <Flex alignItems="center" className="fs--1">
        {rowInfo && (
          <p className="mb-0">
            <span className="d-none d-sm-inline-block me-2">
              {currentPage === 1 ? 1 : pageSize * (currentPage - 1) + 1} to{" "}
              {pageSize * currentPage < totalCount
                ? pageSize * currentPage
                : totalCount}{" "}
              of {totalCount}
            </span>
          </p>
        )}
        {rowsPerPageSelection && (
          <>
            <p className="mb-0 mx-2">Rows per page:</p>
            <Form.Select
              size="sm"
              className="w-auto"
              onChange={(e) => {
                searchParamsHandler("limit", Number(e.target.value));
              }}
              defaultValue={limit}>
              {rowsPerPageOptions.map((value) => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
      </Flex>

      <Flex alignItems="center" justifyContent="center">
        <Button
          size="sm"
          variant="falcon-default"
          onClick={
            currentPage > 1
              ? () => searchParamsHandler("page", currentPage - 1)
              : () => {}
          }>
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
        <ul className="pagination mb-0 mx-1">
          {paginationRange?.map((p) => (
            <li
              key={p}
              className={classNames({
                active: currentPage === p ? true : false,
              })}>
              <Button
                size="sm"
                variant="falcon-default"
                className={classNames("page", {
                  "me-1": p !== Math.ceil(totalCount / pageSize),
                })}
                onClick={() => {
                  p !== "..." && searchParamsHandler("page", Number(p));
                }}>
                {p}
              </Button>
            </li>
          ))}
        </ul>
        <Button
          size="sm"
          variant="falcon-default"
          onClick={
            currentPage < Math.ceil(totalCount / pageSize)
              ? () => searchParamsHandler("page", currentPage + 1)
              : () => {}
          }>
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </Flex>
      {navButtons && (
        <Flex>
          <Button
            size="sm"
            className="mx-2"
            variant={currentPage > 1 ? "primary" : "light"}
            onClick={
              currentPage > 1
                ? () => searchParamsHandler("page", currentPage - 1)
                : () => {}
            }>
            Previous
          </Button>{" "}
          <Button
            size="sm"
            variant={
              currentPage < Math.ceil(totalCount / pageSize)
                ? "primary"
                : "light"
            }
            onClick={
              currentPage < Math.ceil(totalCount / pageSize)
                ? () => searchParamsHandler("page", currentPage + 1)
                : () => {}
            }>
            Next
          </Button>
        </Flex>
      )}
    </Flex>
  );
};

export default AdvanceTableFooter;
